// extracted by mini-css-extract-plugin
export default {"container":"ChangePasswordContainer_container__3OUE1","sectionContainer":"ChangePasswordContainer_sectionContainer__pnnGx"};